
const digest = '3018643eead6b2d28a89fa7d7b6e5ff73fe502caa4eccb45ede5226bb915066d';
const classes = {"wrapper":"_wrapper_1l4jd_1","item":"_item_1l4jd_11"};
const css = `._wrapper_1l4jd_1 {
  display: flex;
  flex-direction: row;
  gap: 20px;
  background-color: #ffffff;
  border: 1px solid #eaedf4;
  padding: 0 12px;
  height: 47px;
}

._item_1l4jd_11 {
  align-self: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  